import { Component, OnInit, SimpleChanges, Input, ElementRef, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { QnASearchService } from '../Services/qna-search.service';
import { QnASearchResultViewModel, QuestionAndAnswer, TocTabPageQnAViewAllBlockModel } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import * as Global from "../Models/constants";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";

declare var ReadStaticData;
let response: string;

@Component({
    selector: 'toctabpage-qna-viewall-answers',
    templateUrl: './toctabpage-qna-viewall-answers.component.html',
    providers: [QnASearchService]
})
export class TocTabPageQnAViewAllAnswersComponent implements OnInit, AfterContentChecked {
    editMode: boolean;
    @Input() public loadingMessage: string;
    form: FormGroup;
    page = 1;
    pageSize = 10;
    maxPages = 10;
    currentPageId: number;
    startIndex: number;
    endIndex: number;
    pager: any = {};
    isLoading: boolean = true;
    searchQuery: string = null;
    filter: string = null;
    searchTag: string;
    isTextSearch: boolean = false;
    isPostedAnswer: boolean = false;
    isEditedQuestion: boolean = false;
    isDeletedQuestion: boolean = false;
    isEditedSection: boolean = false;
    isSelectedCancelButtonId: string = null;
    isSelectedEditButtonId: string = null;
    selectedQuestionId: number;
    postAnswerMessage: string = null;
    postEditQuestionMessage: string = null;
    isQuestionTextAreaClicked: boolean = false;
    isAnswerTextAreaClicked: boolean = false;
    validateAnswerMessage: string = Global.requiredAnswerMessage;
    blankSpaceMessage: string = Global.blankSpaceMessage;
    getQnAFor: string = null;
    btnViewText: string = Global.buttonViewAnsweredQ;
    statuses: string[] = [Global.statusSubmitted];
    tocTabPageQnAViewAllBlockModel: TocTabPageQnAViewAllBlockModel;
    private _searchText: string;
    displayStyleMessageModel: string = 'none';
    displayStyleConfirmationModal: string = 'none';
    pinStatus: boolean = false;
    selectedSection: FormControl;
    selectedEyeIcon: number;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
    }

    private _searchResults: QnASearchResultViewModel<QuestionAndAnswer>;
    get searchResults(): QnASearchResultViewModel<QuestionAndAnswer> {
        return this._searchResults;
    }
    set searchResults(value: QnASearchResultViewModel<QuestionAndAnswer>) {
        this._searchResults = value;
    }
    constructor(public dataService: QnASearchService, private modalService: NgbModal, private element: ElementRef, private sanitizer: DomSanitizer, private cdRef: ChangeDetectorRef, private SpinnerService: NgxSpinnerService) {

    }

    ngOnInit(): void {
        this.form = new FormGroup({
            selectedSection: new FormControl('')
        });;
        this.getStaticData();
        this.dataService.refreshQnA.subscribe(() => {
            this.peformSearch();
        })
        this.peformSearch();
        this.loadingMessage = "Please wait while data is loading.."
    }

    ngAfterContentChecked(): void {
        this.cdRef.detectChanges()
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    peformSearch(): void {
        this.dataService.getSearchResults(this.currentPageId, this.page, this.pageSize, this.searchText, this.filter, this.statuses, this.getQnAFor).subscribe((data: QnASearchResultViewModel<QuestionAndAnswer>) => {
            this.searchResults = data;
            this.setFormvalues(this.searchResults.Items);
            this.searchResults.NoResultMessage = this.tocTabPageQnAViewAllBlockModel.NoResultText;
            this.setPage(this.searchResults);
            this.isLoading = false;
            window.location.href = "#topofbody";
        })
    }

    setFormvalues(inputFields: QuestionAndAnswer[]) {
        try {
            inputFields.forEach(formControl => {
                this.form.addControl('textarea-ans-' + formControl.QuestionId, new FormControl(formControl.Answer, [Validators.required, this.noWhitespaceValidator]));
                this.form.addControl('textarea-qus-' + formControl.QuestionId, new FormControl(formControl.Question, [Validators.required, this.noWhitespaceValidator]));
            })
        }
        catch (error) {
            Global.AddLogs(error);
        }
    }
    getStaticData(): void {
        response = ReadStaticData();
        this.tocTabPageQnAViewAllBlockModel = JSON.parse(response);
        this.pageSize = this.tocTabPageQnAViewAllBlockModel.PageSize;
        this.currentPageId = this.tocTabPageQnAViewAllBlockModel.CurrentPageId;
        this.getQnAFor = this.tocTabPageQnAViewAllBlockModel.GetQnAFor;
    }

    onChangePage(pageIndex: any) {
        this.postAnswerMessage = '';
        this.page = pageIndex;
        this.peformSearch();
    }

    onFilterClick(event, text: any, value: any) {
        this.postAnswerMessage = '';
        document.getElementById("dropdownMenuLink").innerText = "Filter: " + text;
        this.filter = value;
        this.page = 1;
        this.isLoading = true;
        this.peformSearch();
    }

    setPage(searchResults: QnASearchResultViewModel<QuestionAndAnswer>) {
        this.pager = paginate(searchResults.TotalMatching, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

    postAnswers(qna: QuestionAndAnswer, pageId?: any) {
        if (pageId != null) {
            qna.PageId = pageId;
        }
        this.dataService.postAnswers(qna).subscribe((data: boolean) => {
            this.isPostedAnswer = data;
            this.isLoading = false;
            this.postAnswerMessage = this.isPostedAnswer ? "Changes Updated Successfully !" : "Error Occuerd!";
            this.displayStyleMessageModel = "block";
            this.element.nativeElement.querySelector('#messageModel').setAttribute('class', 'modal fade show');
        })
    }

    showConfirmationModal(questionId: number) {
        this.selectedQuestionId = questionId;
        this.displayStyleConfirmationModal = "block";
        this.element.nativeElement.querySelector('#confirmationModal').setAttribute('class', 'modal fade show');
    }

    editQuesion(qna: QuestionAndAnswer, question) {
        qna.Question = question;
        qna.PageId = this.form.get('selectedSection').value;
        this.isSelectedEditButtonId = null;
        this.isSelectedCancelButtonId = null;
        this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).setAttribute('class', 'd-none');
        this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).setAttribute('class', 'd-none');
        this.element.nativeElement.querySelector('#answerdby-' + qna.QuestionId).setAttribute('class', 'd-none');
        
        this.dataService.editQuestion(qna).subscribe((data: boolean) => {
            this.isEditedQuestion = data;
            this.isLoading = false;
            this.postEditQuestionMessage = this.isEditedQuestion ? "Changes Updated Successfully !" : "Error Occuerd!";
            this.displayStyleMessageModel = "block";
            this.element.nativeElement.querySelector('#messageModel').setAttribute('class', 'modal fade show');
        })
    }

    deleteConfirmed() {
        this.dataService.deleteQuestion(this.selectedQuestionId).subscribe((data: boolean) => {
            this.isLoading = false;
            this.displayStyleConfirmationModal = "none";
            this.element.nativeElement.querySelector('#confirmationModal').setAttribute('class', 'modal fade');
        })
    }

    publishAnswer(event, qna: QuestionAndAnswer, question, answer) {
        this.validateAnswerMessage = Global.requiredAnswerMessage;
        this.isPostedAnswer = false;
        var ParentdivId = this.element.nativeElement.querySelector('#parentDiv-' + qna.QuestionId);
        let texareaACollapsible: boolean = this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).getAttribute('class').includes('show');
        switch (event.submitter.innerText.trim()) {
            case Global.unpublishQnA:
                {
                    this.isSelectedEditButtonId = null;
                    this.isSelectedCancelButtonId = null;
                    this.isQuestionTextAreaClicked = false;
                    this.isAnswerTextAreaClicked = false;
                    qna.Action = Global.Action_UnpublishOrReject;
                    //service call to uodate the status of unpublish question
                    this.postAnswers(qna);
                    this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).setAttribute('class', 'd-none');
                    this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).setAttribute('class', 'd-none');
                    this.element.nativeElement.querySelector('#answerdby-' + qna.QuestionId).setAttribute('class', 'd-none');
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.unpublishQnA;
                    break;
                }
            case Global.publishAnswer:
                {
                    qna.Answer = answer;
                    qna.Question = question;
                    this.isSelectedEditButtonId = null;
                    this.isSelectedCancelButtonId = null;
                    this.isQuestionTextAreaClicked = false;
                    this.isAnswerTextAreaClicked = false;
                    //if status is unpublished then update answer and status to "Publish Answer".
                    if (qna.Status == Global.statusUnpublish) {
                        qna.Action = Global.Action_UpdateQnA;
                        this.postAnswers(qna, this.form.get('selectedSection').value);
                        if (!texareaACollapsible) {
                            ParentdivId.setAttribute('class', 'p-2 bg-light');
                            this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).setAttribute('class', 'd-none');
                            this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).setAttribute('class', 'd-none');
                            this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.publishAnswer;
                            this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).setAttribute('class', 'd-none');
                        }
                        break;
                    }
                    else if (qna.Status == Global.statusSubmitted) {
                        //service call to publish question and answer then disappear question.
                        qna.Action = Global.Action_InsertAnswer
                        this.postAnswers(qna);
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.answerQuestion;
                        this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).setAttribute('class', 'd-none');
                        ParentdivId.setAttribute('class', 'p-2');
                        break;
                    }

                }
            case Global.answerQuestion:
                {
                    this.closeAllPanels();

                    ParentdivId.setAttribute('class', 'p-2 bg-light');
                    this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).setAttribute('class', 'form-control rounded py-2');
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).setAttribute('disabled', true);
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.publishAnswer;
                    this.isSelectedCancelButtonId = qna.QuestionId;
                    break;
                }
            case Global.updateQnA:
                {
                    this.isSelectedEditButtonId = null;
                    this.isSelectedCancelButtonId = null;
                    this.isQuestionTextAreaClicked = false;
                    this.isAnswerTextAreaClicked = false;
                    qna.Question = question;
                    if (this.btnViewText == Global.buttonViewUnansweredQ) {
                        qna.Action = Global.Action_UpdateQnA;
                        qna.Answer = answer;
                        qna.PageId = this.form.get('selectedSection').value;
                        this.postAnswers(qna);
                        this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).setAttribute('class', 'd-none');
                        this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).setAttribute('class', 'd-none');
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.unpublishQnA;
                    }
                    else {
                        qna.Action = Global.Action_EditQuestion
                        this.editQuesion(qna, qna.Question);
                    }
                    ParentdivId.setAttribute('class', 'p-2');
                    break;
                }
            default:
                break;
        }
    }

    changeViewPage(event) {
        this.postAnswerMessage = '';
        this.filter = this.searchResults.Filters[0].Value;
        if (this.btnViewText == Global.buttonViewUnansweredQ) {
            this.statuses = [Global.statusSubmitted];
            this.dataService.getSearchResults(this.currentPageId, 1, this.pageSize, this.searchText, this.filter, this.statuses, this.getQnAFor).subscribe((data: QnASearchResultViewModel<QuestionAndAnswer>) => {
                this.searchResults = data;
                this.setFormvalues(this.searchResults.Items);
                this.page = 1;
                this.setPage(this.searchResults);
                this.element.nativeElement.querySelector('#dropdownMenuLink').textContent = "Filter: View All";
            })
            this.btnViewText = Global.buttonViewAnsweredQ;

        }
        else {
            this.statuses = [Global.statusAnswered, Global.statusUnpublish];
            this.dataService.getSearchResults(this.currentPageId, 1, this.pageSize, this.searchText, this.filter, this.statuses, this.getQnAFor).subscribe((data: QnASearchResultViewModel<QuestionAndAnswer>) => {
                this.searchResults = data;
                this.setFormvalues(this.searchResults.Items);
                this.page = 1;
                this.setPage(this.searchResults);
                this.element.nativeElement.querySelector('#dropdownMenuLink').textContent = "Filter: View All";
            })
            this.btnViewText = Global.buttonViewUnansweredQ;
        }
    }

    editAnswer(event, qna: QuestionAndAnswer) {
        //  this.closeAllPanels();
        this.editMode = true;
        this.isSelectedEditButtonId = qna.QuestionId;
        this.isQuestionTextAreaClicked = false;
        this.form.get('selectedSection').setValue(qna.PageId);
        let texareaCollapsible: boolean = event.target.parentElement.nextElementSibling.nextElementSibling.getAttribute('class').includes('show');
        var answerText = qna.Answer;
        var questionText = qna.Question;
        this.sanitizer.bypassSecurityTrustHtml(answerText);
        this.sanitizer.bypassSecurityTrustHtml(questionText);

        //close all other parent div's if expanded.
        if (!texareaCollapsible) {
            this.searchResults.Items.forEach(qna => {
                var isCollapsible = this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).getAttribute('class').includes('show');
                if (isCollapsible) {
                    if (qna.Status == Global.statusUnpublish) {
                        this.form.reset();
                        this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse')
                        this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse')
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.updateQnA;
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).setAttribute('class', 'd-none');
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).removeAttribute('disabled', true);
                        this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).value = answerText;
                        this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).value = questionText;
                    }
                    else if (qna.Status == Global.statusAnswered) {
                        this.form.reset();
                        this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse')
                        this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse')
                        this.element.nativeElement.querySelector('#textarea-ans-' + qna.QuestionId).value = answerText;
                        this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).value = questionText;
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.unpublishQnA;
                        this.element.nativeElement.querySelector('#parentDiv-' + qna.QuestionId).setAttribute('class', 'p-2');
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).removeAttribute('disabled', true);
                    }
                    else if (qna.Status == Global.statusSubmitted) {
                        // Close answer panels from Submitted questions
                        this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse');
                        this.element.nativeElement.querySelector('#parentDiv-' + qna.QuestionId).setAttribute('class', 'p-2');
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.answerQuestion;
                        this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).removeAttribute('disabled', true);
                        this.isSelectedCancelButtonId = null;
                    }
                }
            })
        }

        //Expand/ collapse current div.
        if (qna.Status == Global.statusUnpublish) {
            if (!texareaCollapsible) {
                this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse show');
                this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse show');
                this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'btn btn-primary .btn-outline-transparent .shadow-none rounded-pill my-3 mr-3');
            }
            else {
                this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse');
                this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse');
                this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'd-none');
                this.isSelectedEditButtonId = null;
            }
            this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).textContent = Global.publishAnswer;
            this.element.nativeElement.querySelector('#textarea-ans-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
            this.element.nativeElement.querySelector('#textarea-ans-' + event.target.getAttribute('id').split('-')[2]).value = answerText;
            this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
            this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).value = questionText;
        }
        else {
            if (!texareaCollapsible) {
                this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse show');
                this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse show');
                this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).textContent = Global.updateQnA;
                this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'btn btn-primary .btn-outline-transparent .shadow-none rounded-pill my-3 mr-3');
                this.element.nativeElement.querySelector('#parentDiv-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'p-2 bg-light');
                this.element.nativeElement.querySelector('#textarea-ans-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
                this.element.nativeElement.querySelector('#textarea-ans-' + event.target.getAttribute('id').split('-')[2]).value = answerText;
                this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
                this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).value = questionText;
            }
            else {
                this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse');
                this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse');
                this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).textContent = Global.unpublishQnA;
                this.element.nativeElement.querySelector('#parentDiv-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'p-2');
                this.element.nativeElement.querySelector('#textarea-ans-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
                this.element.nativeElement.querySelector('#textarea-ans-' + event.target.getAttribute('id').split('-')[2]).value = '';
                this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
                this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).value = '';
                this.isSelectedEditButtonId = null;
            }
        }
    }

    cancelButton(event, qna: QuestionAndAnswer) {
       this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.answerQuestion;
       this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).removeAttribute('disabled', true);
        this.element.nativeElement.querySelector('#parentDiv-' + qna.QuestionId).setAttribute('class', 'p-2');
        this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse')
        this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse')
        this.isSelectedCancelButtonId = null;
        this.isSelectedEditButtonId = null;
        this.isQuestionTextAreaClicked = false;
        this.isAnswerTextAreaClicked = false;
    }
    editQuestion(event, qna: QuestionAndAnswer) {
        let texareaCollapsible: boolean = event.target.parentElement.nextElementSibling.nextElementSibling.getAttribute('class').includes('show');
        //  this.closeAllPanels();         
        var questionText = qna.Question;
        this.sanitizer.bypassSecurityTrustHtml(questionText);
        this.isSelectedEditButtonId = qna.QuestionId;
        this.form.get('selectedSection').setValue(qna.PageId);
         
        //close all other parent div's if expanded.
        if (!texareaCollapsible) {
            this.searchResults.Items.forEach(qna => {
             // Close any open question panels
                var isQusCollapsible = this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).getAttribute('class').includes('show');
                if (isQusCollapsible) {
                    this.element.nativeElement.querySelector('#qus-' + qna.QuestionId).setAttribute('class', 'collapse')
                    this.element.nativeElement.querySelector('#textarea-qus-' + qna.QuestionId).value = questionText;
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.answerQuestion;
                    this.element.nativeElement.querySelector('#parentDiv-' + qna.QuestionId).setAttribute('class', 'p-2');
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).removeAttribute('disabled', true);
                    this.isSelectedEditButtonId = null;
                }
                // Close any open answer panels
                var isAnsCollapsible = this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).getAttribute('class').includes('show');
                if (isAnsCollapsible) {
                    this.element.nativeElement.querySelector('#ans-' + qna.QuestionId).setAttribute('class', 'collapse');
                    this.element.nativeElement.querySelector('#parentDiv-' + qna.QuestionId).setAttribute('class', 'p-2');
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).textContent = Global.answerQuestion;
                    this.element.nativeElement.querySelector('#qna-btnAnswer-' + qna.QuestionId).removeAttribute('disabled', true);
                    this.isSelectedCancelButtonId = null;
                }
            })
        }
        //Expand/ collapse current div.
        if (!texareaCollapsible) {
            this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).textContent = Global.updateQuestion;
            this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'btn btn-primary .btn-outline-transparent .shadow-none rounded-pill my-3');
            this.element.nativeElement.querySelector('#parentDiv-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'p-2 bg-light');
            this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
            this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).value = questionText;
            this.isSelectedEditButtonId = qna.QuestionId;
        }
        else {
            this.element.nativeElement.querySelector('#qna-btnAnswer-' + event.target.getAttribute('id').split('-')[2]).textContent = Global.answerQuestion;
            this.element.nativeElement.querySelector('#parentDiv-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'p-2');
            this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).setAttribute('class', 'form-control rounded py-2');
            this.element.nativeElement.querySelector('#textarea-qus-' + event.target.getAttribute('id').split('-')[2]).value = '';
            this.isSelectedEditButtonId = null;
        }
    }

    closePopup() {
        this.displayStyleMessageModel = "none";
        this.displayStyleConfirmationModal = "none";
        this.element.nativeElement.querySelector('#messageModel').setAttribute('class', 'modal fade');
        this.element.nativeElement.querySelector('#confirmationModal').setAttribute('class', 'modal fade');
    }

    answerChanged(value, btnId) {
        if (value != null) {
            if (value.trim() == '') {
                if (this.element.nativeElement.querySelector('#' + btnId) != null)
                    this.element.nativeElement.querySelector('#' + btnId).setAttribute('disabled', true)
            }
            else {
                if (this.element.nativeElement.querySelector('#' + btnId) != null)
                    this.element.nativeElement.querySelector('#' + btnId).removeAttribute('disabled', true)
            }
        }
    }

    public noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }

    changePinStatus(qna: QuestionAndAnswer) {
        qna.IsPinned = !qna.IsPinned;
        this.dataService.changePinStatus(qna.QuestionId, qna.IsPinned).subscribe((data: boolean) => {
            qna.IsPinned = data;
        })
    }

    refreshQnA() {
        this.SpinnerService.show();
        this.isLoading = true;
        this.page = 1;
        this.onChangePage(this.page);
        setTimeout(() => {
            this.isLoading = false;
            this.SpinnerService.hide();
        }, 2000);
    }

    toggleIcons(id: number) {
        if (this.selectedEyeIcon == id) {
            this.selectedEyeIcon = null;
        }
        else {
            this.selectedEyeIcon = id;
        }
    }

         // Close all expanded panels - only one question panel open at a time                                               
        closeAllPanels() {                                                                                                  
          this.searchResults.Items.forEach(item => {                                                                      
                  this.element.nativeElement.querySelector('#ans-' + item.QuestionId)?.setAttribute('class',                  
          'collapse');                                                                                                             
                  this.element.nativeElement.querySelector('#qus-' + item.QuestionId)?.setAttribute('class',                  
          'collapse');                                                                                                             
                   this.element.nativeElement.querySelector('#parentDiv-' + item.QuestionId)?.setAttribute('class',            
          'p-2');                                                                                                                  
                  if (item.Status == Global.statusSubmitted) {                                                                
                      this.element.nativeElement.querySelector('#qna-btnAnswer-' + item.QuestionId).textContent =             
          Global.answerQuestion;                                                                                                   
                  } else if (item.Status == Global.statusAnswered) {                                                          
                      this.element.nativeElement.querySelector('#qna-btnAnswer-' + item.QuestionId).textContent =             
          Global.unpublishQnA;                                                                                                     
                  }                                                                                                           
                 this.element.nativeElement.querySelector('#qna-btnAnswer-' +                                                
          item.QuestionId)?.removeAttribute('disabled');                                                                           
            });                                                                                                             
             this.isSelectedEditButtonId = null;                                                                             
              this.isSelectedCancelButtonId = null;                                                                           
          }  
}
